export const tableSize = 50;

export interface DriversApiResponse {
  items: DriverItem[];
  nextCursor: number | null;
}

export interface DriverItem {
  id: number;
  driverId: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  domicileTerminalNumber: string | null;
  status: string;
  statusChangedAt: string | null;
  statusChangedBy: string | null;
  lastTelematicsSyncedAt: string | null;
  createdAt: string;
  createdBy: string | null;
  updatedAt: string;
  updatedBy: string | null;
  address: Address | null;
  commercialDriverLicense: CommercialDriverLicense | null;
  payRates: PayRate[];
}

export interface Address {
  [key: string]: any;
}

export interface CommercialDriverLicense {
  id: string;
  licenseNumber: string;
  licenseClass: string | null;
  issueState: string | null;
  issuedDate: string | null;
  expirationDate: string | null;
  medicalCardExpiration: string | null;
  createdAt: string;
  createdBy: string | null;
  updatedAt: string;
  updatedBy: string | null;
  driverInternalId: number;
  endorsements: any[];
  restrictions: any[];
}

export interface PayRate {
  id: string;
  payType: string;
  amount: string;
  adjustment: string | null;
  editable: boolean;
  createdAt: string;
  createdBy: string | null;
  updatedAt: string;
  updatedBy: string | null;
  driverInternalId: number;
}
